class SectionFaq extends HTMLElement {
  constructor() {
    super();
    this.init()
  }
  init() {
    const _this = this;
    $(this)
      .find('.category_block')
      .on('click', function () {
        const { category } = $(this).data();
        console.log(category)
        if (category) {
            const headerHeight = $('html')[0].style.getPropertyValue('--header-section-height')
          $('html, body').animate({
            scrollTop: $(`#${category}`).offset().top - parseInt(headerHeight)
          }, 800); // 800ms 滚动持续时间
        }
      });
  }
}

$(document).ready(function () {
  customElements.define('section-faq', SectionFaq);
});
